import React from 'react';
import PropTypes from 'prop-types';
import { newElementId } from '../utils/ids';

export default class FileUpload extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      errors: [],
    };
  }
  componentWillMount() {
    this.elementId = newElementId('file-input');
  }

  handleChange(ev) {
    const { files } = ev.target;
    if (files && files.length) {
      for (let i = 0; i < files.length; i += 1) {
        this.props
          .reader(files[i])
          .then((songData) => {
            this.props.onUpload(songData);
          })
          .catch((err) => {
            this.setState({
              ...this.state,
              errors: [{ name: files[i].name, err }, ...this.state.errors],
            });
          });

        // let f = null;
        // try {
        //   f = this.props.reader(files[i]);
        // } catch (err) {
        //   this.setState({
        //     ...this.state,
        //     errors: [{ name: files[i].name, err }, ...this.state.errors],
        //   });
        // }
        // if (f) {
        //   this.props.onUpload(f);
        // }
      }
    }
  }

  render() {
    return (
      <div>
        <p>
          Use this to upload a song json file that was previously exported from this app. Use this
          to share songs between devices. This is a temporary hack until we have implemented proper
          syncing between devices.
        </p>
        <input
          id={this.elementId}
          type="file"
          multiple={this.props.multiple}
          onChange={this.handleChange}
        />
        {this.state.errors && (
          <ul className="text-danger my-3">
            {this.state.errors.map((err, index) => (
              <li key={index}>
                <b className="mr-2">{err.name}:</b>
                {err.err.message}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}
FileUpload.propTypes = {
  multiple: PropTypes.bool,
  reader: PropTypes.func,
  onUpload: PropTypes.func,
};
FileUpload.defaultProps = {
  multiple: false,
  reader: undefined,
  onUpload: undefined,
};



// WEBPACK FOOTER //
// ./src/components/FileUpload.js